import _ from 'lodash';
import { ListingEvent } from 'js/types/events';

export const FETCH_URL = '/listing';
export const RESET_FILTERS_URL = '/listing/filters/reset';
export const FAVORITES_URL = '/favorites';

import state from './listingState';
import LocalStorage from '../../core/commons/LocalStorage';
import SessionStorage from '../../core/commons/SessionStorage';

const localStorageNamespace = 'listing_context';

export const mutations = {
    init(state, props) {
        state.url = props.url;
        state.linkedtype = props.linkedtype;
        state.params = props.params;
        state.favorite = props.favorite;
        state.prefilter = props.prefilter;
        state.listingname = props.name;
        state.favoritesName =
            props.favoritesName != undefined && props.favoritesName != ''
                ? props.favoritesName
                : props.name;
        state.savedSearchesUrl = props.savedSearchesUrl ? props.savedSearchesUrl : '';
        state.useFavorites = props.useFavorites;
        state.exportUrl = props.exportUrl;
        state.metaUrl = props.metaUrl;
        state.aggregations = props.aggregations;
        state.enableContext = props.enableContext;
    },

    flagInit(state) {
        state.init = false;
    },

    updateFilters(state, filterset) {
        state.filters = filterset;
    },

    applyFilter(state, filter) {
        const filterIndex = _.findIndex(state.filters, { name: filter.name });

        if (filterIndex != -1) {
            state.filters[filterIndex] = filter;
        } else if (filterIndex == -1 && state.init) {
            state.filters.push(filter);
        }
    },

    removeFilter(state, filter) {
        const filterIndex = _.findIndex(state.filters, { name: filter.name });

        if (filterIndex != -1) {
            state.filters[filterIndex].data = {};
            state.filters[filterIndex].active = false;
            state.filters[filterIndex].pending = false;
        }
    },

    // Display options
    toggleDisplay(state, toDisplay) {
        state.display.columns = false;
        state.display.table = false;
        state.display.export = false;

        state.display[toDisplay] = !state.display[toDisplay];
    },

    showDisplay(state, toDisplay) {
        state.display[toDisplay] = true;
    },
    hideDisplay(state, toDisplay) {
        state.display[toDisplay] = false;
    },
    updateFiltersView(state, view) {
        const views = ['summary', 'select', 'setup', 'allFavoris'];
        if (!views.includes(view)) {
            return;
        }
        state.display.filtersView = view;
    },

    updateExportType(state, type) {
        if (!['csv', 'pdf', 'fec', 'advanced'].includes(type)) {
            return;
        }

        state.display.exportType = type;
    },

    // Pagination
    setupPagination(state, pagination) {
        state.pagination = pagination;
    },

    updateCurrentPage(state, page) {
        state.pagination.current_page = page;
    },

    updatePerPage(state, per_page) {
        state.pagination.per_page = per_page;
    },

    // Columns
    updateColumns(state, columns) {
        state.columns = columns;
    },

    // BATCH ACTIONS
    updateBatchActions(state, batchActions) {
        state.batchActions = batchActions;
    },

    // SORTING
    updateSorting(state, payload) {
        state.sorting = payload;
    },

    updateRows(state, rows) {
        state.rows = rows;
    },

    // add additional infos in session storage for mass actions
    updateMoreInfos(state, data) {
        if (['purchaseorders', 'purchasedeliveries'].includes(data.meta.listingName)) {
            if (Object.keys(data.data).length > 0) {
                state.moreInfos = data.data.map((obj) =>
                    Object.fromEntries(
                        Object.entries(obj).filter(([key]) =>
                            ['linkedtype', 'id', 'step', 'deliveryStep', 'thirds_concat'].includes(
                                key,
                            ),
                        ),
                    ),
                );
                const sessionStorage = new SessionStorage(
                    localStorageNamespace,
                    data.meta.listingName + '_more_infos',
                );
                sessionStorage.set(state.moreInfos);
            }
        }
    },

    // add additional infos in session storage for mass actions
    updateMoreInfos(state, data) {
        if (['purchaseorders', 'purchasedeliveries'].includes(data.meta.listingName)) {
            if (Object.keys(data.data).length > 0) {
                state.moreInfos = data.data.map((obj) =>
                    Object.fromEntries(
                        Object.entries(obj).filter(([key]) =>
                            ['linkedtype', 'id', 'step', 'deliveryStep', 'thirds_concat'].includes(
                                key,
                            ),
                        ),
                    ),
                );
                const sessionStorage = new SessionStorage(
                    localStorageNamespace,
                    data.meta.listingName + '_more_infos',
                );
                sessionStorage.set(state.moreInfos);
            }
        }
    },

    setAjax(state, xhttpRequest) {
        state.ajax = xhttpRequest;
    },

    setError(state) {
        state.error = true;
        state.rows = [];
    },

    deleteError(state) {
        state.error = false;
    },

    updatePermissions(state, permissions) {
        state.permissions = permissions;
    },

    updateFavorites(state, favorites) {
        state.favorites = favorites;
    },

    updateFavorite(state, favorite) {
        const index = _.findIndex(state.favorites, { id: '' + favorite.id });

        if (index != -1) {
            state.favorites.splice(index, 1, favorite);
        } else {
            state.favorites.push(favorite);
        }
    },

    deleteFavorite(state, favoriteId) {
        const index = _.findIndex(state.favorites, { id: '' + favoriteId });

        if (index != -1) {
            state.favorites.splice(index, 1);
        }
    },

    updateFavoriteData(state, data) {
        state.favoriteData = data;
    },

    updateFavoriteBack(state, value) {
        state.display.backToFavorites = value;
    },

    updateFullExport(state, value) {
        state.hasFullExport = value;
    },

    updateKpiPresence(state, value) {
        state.hasKpis = value;
    },

    updateKpis(state, kpis) {
        // Backend KPI payloads can contain null entries (e.g. stale/partial cached
        // indicators); filter them out so KpiList never reads a property off null.
        state.kpis = Array.isArray(kpis)
            ? kpis.filter((kpi) => kpi !== null && kpi !== undefined)
            : kpis;
    },

    updateDisplay(state, display) {
        for (const toDisplay in display) {
            if (display[toDisplay] === 'true' || display[toDisplay] === 'false') {
                display[toDisplay] = display[toDisplay] == 'true';
            }
            state.display[toDisplay] = display[toDisplay];
        }
    },
    updateBatchData(state, payload) {
        state.batchData = payload;
    },
    updateColumnSize(state, column) {
        // If array doesn't exist then create
        if (_.isNil(state.columnsSize[state.listingname])) {
            state.columnsSize[state.listingname] = [];
        }

        // If item is find, update or push new item
        if (state.columnsSize[state.listingname].find((item) => item.name === column.name)) {
            const index = state.columnsSize[state.listingname].findIndex(
                (item) => item.name === column.name,
            );
            state.columnsSize[state.listingname][index] = column;
        } else {
            state.columnsSize[state.listingname].push(column);
        }
    },
    updateColumnsSize(state, columns) {
        state.columnsSize[state.listingname] = [];
        columns.forEach((column) => {
            state.columnsSize[state.listingname].push(column);
        });
    },
    updateMustSelectFullRow(state, value) {
        state.mustSelectFullRow = value;
    },

    updateListingName(state, payload) {
        state.listingname = payload.listingname;
    },

    updateListingHash(state, listingHash) {
        state.listingHash = listingHash;
    },

    setIsLoadingKpis(state, value) {
        state.isLoadingKpis = value;
    },

    setDraftCounts(state, counts) {
        state.draftCounts = counts;
    },
};

export const getters = {
    activeFilters: (state) => state.filters.filter((filter) => filter.active),

    topFilters: (state) =>
        state.filters
            .filter((filter) => filter.topscore !== false)
            .sort((a, b) => (a - b < 0 ? 1 : -1)),

    pendingFilters: (state) => state.filters.filter((filter) => !!filter.pending && !filter.active),

    filterData: (state) => {
        var data = {};
        for (var filterIndex in state.filters) {
            const filter = state.filters[filterIndex];

            if (filter.active || filter.pending) {
                data[filter.name] = filter.data;
            }
        }

        return data;
    },

    activeColumns: (state) => {
        return state.columns.filter((column) => column.display).sort((a, b) => a.rank - b.rank);
    },

    favoriteSharedUrl: (state) => (id) => {
        if (id) {
            let queryString = '?favorite=' + id;
            if (/\?/gi.test(state.url)) {
                queryString = '&favorite=' + id;
            }

            return state.url.includes(window.location.origin)
                ? state.url + queryString
                : window.location.origin + window.location.pathname + queryString;
        }

        return false;
    },

    favoriteShortcuts: (state) => {
        if (state.favorites && Array.isArray(state.favorites)) {
            return state.favorites
                .filter((favorite) => favorite.shortcut)
                .sort((a, b) => (a.rank - b.rank > 0 ? -1 : 1));
        }
        return [];
    },

    meta: (state, getters) => {
        let meta = {
            columns: [],
            pagination: state.pagination,
            sorting: state.sorting,
            filters: [],
        };

        if (state.init) {
            meta = {
                filters: [],
            };
        }

        if (state.prefilter) {
            meta.prefilter = state.prefilter;
        }

        meta.filters = {
            ...getters.filterData,
        };

        if (meta.columns != undefined) {
            for (const column of getters.activeColumns) {
                meta.columns.push(column.name);
            }
        }

        return meta;
    },
    batchData(state) {
        return state.batchData;
    },

    permissions(state) {
        return state.permissions || {};
    },

    isLoadingKpis(state) {
        return state.isLoadingKpis;
    },
};

export const actions = {
    permissionDenied() {
        Push.info(
            window.i18n.gettext('Vous ne disposez pas des droits nécessaires pour cette action.'),
        );
    },
    init({ dispatch, commit }, props) {
        commit('init', props);

        for (const i in props.filter) {
            const filter = {
                name: i,
                data: props.filter[i],
                pending: true,
            };

            commit('applyFilter', filter);
        }
    },

    resetColumns({ dispatch, commit, state }) {
        return new Promise((resolve, reject) => {
            commit(
                'setAjax',
                SellsyJS.WebServiceCaller.del(
                    `/listing/${state.listingname}/columns`,
                    {
                        meta: {
                            prefilter: state.prefilter ? state.prefilter : {},
                        },
                    },
                    function (json) {
                        commit('setAjax', false);
                        if (json.error === undefined) {
                            dispatch('refreshData', json);
                            resolve(json);
                        } else {
                            commit('setError');
                            reject;
                        }
                    },
                    function () {
                        commit('setError');
                        reject;
                    },
                ),
            );
        });
    },

    resetFilters({ commit, getters, state }, apply = true) {
        for (const filter of getters.activeFilters) {
            commit('removeFilter', filter);
        }
        for (const filter of getters.pendingFilters) {
            commit('removeFilter', filter);
        }

        if (!apply) {
            return;
        }

        commit('updateFiltersView', 'select');
        commit(
            'setAjax',
            SellsyJS.WebServiceCaller.del(
                `/listing/${state.listingname}/filters`,
                {},
                () => {
                    commit('setAjax', false);
                    EventBus.emit(ListingEvent.REFRESH);
                },
                () => {
                    commit('setAjax', false);
                    commit('setError');
                },
            ),
        );
    },

    removeFilter({ commit }, filter) {
        const pending = filter.pending;

        commit('removeFilter', filter);

        if (!pending) {
            EventBus.emit(ListingEvent.REFRESH);
        }
    },

    editFilter({ dispatch, commit }, filter) {
        commit('showDisplay', 'filters');
        EventBus.emit('filters:edit', filter);
    },

    filterEditable({ dispatch, state }, filter) {
        return !_.has(state.prefilter, filter.name);
    },

    updateColumns({ state, getters }) {
        var columns = getters.activeColumns.map((col) => col.name);

        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.post(
                `/listing/${state.listingname}/columns`,
                {},
                {
                    columns: columns,
                },
                function (response) {
                    resolve(response);
                },
                function () {
                    reject;
                },
            );
        });
    },

    resetListing({ dispatch, state, commit }) {
        if (state.error) {
            commit('deleteError');
        }

        const ajax = SellsyJS.WebServiceCaller.del(
            `/listing/${state.listingname}`,
            {
                meta: {
                    prefilter: state.prefilter ? state.prefilter : {},
                },
            },
            function (response) {
                dispatch('refreshData', response);
                commit('setAjax', false);
            },
            function () {
                commit('setAjax', false);
            },
        );

        commit('setAjax', ajax);
    },

    reloadKpis({ dispatch, state, commit }) {
        if (state.error) {
            commit('deleteError');
        }

        dispatch('setIsLoadingKpis', true);

        const ajax = SellsyJS.WebServiceCaller.post(
            `/listing/${state.listingname}/kpis`,
            {},
            {},
            function (response) {
                commit('updateKpis', response.kpis);
                commit('setAjax', false);
                dispatch('setIsLoadingKpis', false);
            },
            function () {
                commit('setAjax', false);
                dispatch('setIsLoadingKpis', false);
            },
        );

        commit('setAjax', ajax);
    },

    refreshData({ dispatch, state, commit }, data) {
        commit('setupPagination', data.meta.pagination);
        commit('updateFilters', data.meta.filters);
        commit('updateColumns', Object.values(data.meta.columns));
        commit('updateSorting', data.meta.sorting);
        dispatch('sortUpdated', data.meta.sorting);
        commit('updatePermissions', data.permissions);
        commit('updateFullExport', data.hasFullExport);
        commit('updateKpiPresence', data.hasKpis);

        if (data.draftCounts) {
            commit('setDraftCounts', data.draftCounts);
        }

        if (data.meta.columnsSize) {
            commit('updateColumnsSize', data.meta.columnsSize);
        }

        if (state.init) {
            //Remove action to update third's prefs
            if (data.meta.listingName === 'companies' || data.meta.listingName === 'individuals')
                delete data.batchActions.updatePrefsThird;
            commit('updateBatchActions', Object.values(data.batchActions));
            commit('updateDisplay', data.meta.display);
            commit('flagInit');
        }

        if (data.kpis) {
            commit('updateKpis', data.kpis);
        } else if (data.meta.display.kpi) {
            dispatch('reloadKpis');
        }

        commit('updateRows', Object.keys(data.data).length > 0 ? data.data : {});
        commit('updateMoreInfos', data);
        if (data.saveContext) {
            dispatch('saveContext');
        }
    },

    sortUpdated({ commit, state }, payload) {
        window.EventBus.emit('listing:sortUpdated', payload);
    },

    fetchFavorites({ commit, state }) {
        if (state.favorites.length == 0) {
            SellsyJS.WebServiceCaller.get(
                `${FAVORITES_URL}/${state.favoritesName}`,
                {},
                function (response) {
                    commit('updateFavorites', response.data);
                },
            );
        }
    },

    editFavorite({ commit, state }, favorite) {
        commit('updateFavoriteData', favorite);
        commit(`showDisplay`, 'favoritesForm');

        if (state.display.favorites) {
            commit('updateFavoriteBack', true);
        } else {
            commit('updateFavoriteBack', false);
        }
        commit(`hideDisplay`, 'favorites');
    },

    toggleDisplay({ commit, dispatch }, toDisplay) {
        commit('toggleDisplay', toDisplay);

        if (toDisplay == 'filters') {
            dispatch('updateDisplay');
        }
    },

    updateDisplay: _.debounce(({ commit, state }) => {
        new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.post(
                `/listing/${state.listingname}/display`,
                {},
                {
                    display: _.pick(state.display, ['filters', 'density', 'kpi']),
                },
                function (response) {
                    resolve(response);
                },
                function (error) {
                    reject;
                },
            );
        });
    }, 500),

    saveContext({ state, getters }) {
        //Init local storage for overview pagination
        if (!state.contextStorage) {
            state.contextStorage = new LocalStorage(localStorageNamespace, state.listingname);
        }

        const ids =
            state.rows.length !== undefined
                ? state.rows.filter((row) => row.id !== undefined).map((row) => row.id)
                : [];

        const meta = Object.assign({}, getters.meta);
        delete meta.columns;

        state.contextStorage.set({
            meta: meta,
            ids: ids,
            pages: [meta.pagination.current_page],
        });
    },

    updateColumnsSettings({ dispatch, getters, state, commit }, meta) {
        commit('updateColumnSize', { name: meta.column.property, width: meta.newWidth });
        const columnsSize = (state.columnsSize[state.listingname] || []).filter(
            (col) =>
                col.name && col.name !== 'compassMassCheckboxCell' && col.name !== 'contextMenu',
        );
        const data = {
            meta: {
                columnsSize,
            },
        };
        return new Promise((resolve) => {
            SellsyJS.WebServiceCaller.post(
                `${FETCH_URL}/${state.listingname}`,
                {},
                data,
                function (response) {
                    resolve(response);
                },
                function () {
                    commit('setError');
                },
            );
        });
    },

    getAllPages({ state, commit, getters }) {
        const currentMeta = Object.assign({}, getters.meta);
        delete currentMeta.columns; // we only need ids
        const datas = {
            init: false,
            meta: currentMeta,
            persist: false,
        };

        return new Promise((resolve, reject) => {
            commit(
                'setAjax',
                SellsyJS.WebServiceCaller.post(
                    `${FETCH_URL}/${state.listingname}/allpages`,
                    {},
                    datas,
                    function (response) {
                        commit('setAjax', false);
                        resolve(response.rows);
                    },
                    function (response) {
                        reject();
                        commit('setAjax', false);
                    },
                ),
            );
        });
    },

    runExport({ commit, state }, data) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.post(
                `/listing/${state.listingname}/export`,
                {},
                data,
                resolve,
                reject,
            );
        });
    },

    updateListingHash({ commit }, listingHash) {
        commit('updateListingHash', listingHash);
    },

    setIsLoadingKpis({ commit }, value) {
        commit('setIsLoadingKpis', value);
    },
};

export default {
    namespaced: true,
    state() {
        return JSON.parse(JSON.stringify(state));
    },
    getters: getters,
    mutations: mutations,
    actions: {
        ...actions,

        fetch({ dispatch, getters, state, commit }, payload) {
            if (state.error) {
                commit('deleteError');
            }

            var data = {
                meta: getters.meta,
                ...state.params,
            };
            if (payload != undefined && payload.overwriteMeta !== undefined) {
                data.meta = overwriteMeta;
                data.meta.pagination = { current_page: 1 };
            }

            if (payload != undefined && payload.kpis !== undefined) {
                data.kpis = payload.kpis;
            }

            if (state.init) {
                data.init = state.init;
            }

            if (state.init && state.favorite) {
                data.favorite = state.favorite;
            }
            return new Promise((resolve, reject) => {
                commit(
                    'setAjax',
                    SellsyJS.WebServiceCaller.post(
                        `${FETCH_URL}/${state.listingname}`,
                        {},
                        data,
                        function (response) {
                            dispatch('refreshData', response);
                            commit('setAjax', false);
                            resolve(response);
                        },
                        function (response) {
                            reject;
                            commit('setAjax', false);
                            commit('setError');
                        },
                    ),
                );
            });
        },
    },
};
